module.exports = function fail(message) {
  throw new TypeError('[tcomb] ' + message);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/fail.js
 ** module id = 7
 ** module chunks = 0
 **/